import { useIsEmployerUserVerified } from "@js/apps/common/hooks/is-employer-verified";
import { openSubscribeTeamMembersToJobModal } from "@js/apps/employer/components/subscribe-team-members-to-job-modal";
import type { Job } from "@js/types/jobs";

import { useGetJobSubscribersQuery } from "../../api";
import { useCanAddTeamMembersToJob } from "../../hooks/use-can-add-team-members-to-job";
import { AddTeamMembersButton } from "../add-team-members-button";

type JobManagementHeaderAddTeamMembersButtonProps = { job: Job };

export const JobManagementHeaderAddTeamMembersButton = ({
  job,
}: JobManagementHeaderAddTeamMembersButtonProps) => {
  const { canAddTeamMembersToJob } = useCanAddTeamMembersToJob(job.creator?.id);
  const isEmployerVerified = useIsEmployerUserVerified();
  const showAddTeamMembersButton = canAddTeamMembersToJob && isEmployerVerified;
  const { data: jobSubscribers } = useGetJobSubscribersQuery(
    { jobId: job.id },
    { skip: !showAddTeamMembersButton },
  );

  if (!showAddTeamMembersButton) {
    return <></>;
  }

  return (
    <AddTeamMembersButton
      jobSubscribers={jobSubscribers ?? []}
      onClick={() => {
        openSubscribeTeamMembersToJobModal({
          jobId: job.id,
          jobOwnerId: job.creator?.id,
        });
      }}
    />
  );
};
